import PropTypes from "prop-types";

const propTypes = {
  faktObsah: PropTypes.shape({
    I_ZIS_FAKT_OB: PropTypes.number,
    I_ZIS_FAKT_HL: PropTypes.number,
    UCT_POLOZKA_NAZOV: PropTypes.string,
    I_POLOZKA: PropTypes.number,
    MNOZSTVO: PropTypes.number,
    MJ: PropTypes.string,
    JEDNCENA: PropTypes.number,
    SADZBADPH: PropTypes.number,
    CENABEZDPH: PropTypes.number,
    DPH: PropTypes.number,
    CENASDPH: PropTypes.number,
    JEDNCENA_F: PropTypes.string,
    SADZBADPH_F: PropTypes.string,
    CENABEZDPH_F: PropTypes.string,
    DPH_F: PropTypes.string,
    CENASDPH_F: PropTypes.string,
  }),
};

export default propTypes;
